import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Customer/Documents/$id')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.contractingManualDocumentsEnabled);
    },
    staticData: {
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
        title: TextKey.ContractsTitle,
    },
    component: () => <div />,
});
